module.exports = {"name":"dashjs","type":"adapter","tech":"js","author":"Jesus Lopez","version":"6.1.0","built":"2018-01-24","repo":"https://bitbucket.org/npaw/dashjs-adapter-js","libVersion":"6.1.9","features":{"buffer":"monitor","seek":"native","getters":["getPlayhead","getDuration","getBitrate","getThroughput","getIsLive","getResource"]},"ads":[]}


//////////////////
// WEBPACK FOOTER
// ./manifest.json
// module id = 26
// module chunks = 0